import { Dropdown, Menu } from "antd";
import { Button } from "components/Button/Button";
import { Icon } from "components/Icon/Icon";
import Tooltip from "components/Tooltip/Tooltip";
import React, { PropsWithChildren, ReactNode } from "react";
import "./DropdownButton.scss";

export const ActionDropdownButton = ({
    parentAction,
    label,
    iconByName,
    icon,
    isDisabled,
    children,
    dropdownIcon,
    tooltipOverlay,
    image,
    overlayClassName,
    isLoading,
}: any) => {
    const getIcon = ({ icon, iconByName }) =>
        icon ? <Icon icon={icon} byName={iconByName} /> : null;

    const overlay = <Menu>{children}</Menu>;
    const buttonsRender = tooltipOverlay?.length
        ? {
              buttonsRender: ([leftButton, rightButton]: ReactNode[]) =>
                  [
                      <Tooltip overlay={tooltipOverlay} placement="top" key="leftButton">
                          {leftButton}
                      </Tooltip>,
                      React.cloneElement(rightButton as React.ReactElement<any, string>),
                  ] as ReactNode[],
          }
        : {};

    return (
        <Dropdown.Button
            className={`actionDropdownButton${isDisabled ? " button--disabled" : ""}${
                isLoading ? " button--isLoading" : ""
            }`}
            onClick={parentAction}
            overlay={overlay}
            icon={dropdownIcon}
            overlayClassName={overlayClassName}
            {...buttonsRender}
        >
            {image ?? getIcon({ icon, iconByName })}
            {label}
        </Dropdown.Button>
    );
};

interface ActionDropdownButtonWithoutParentProps {
    isDisabled?: boolean;
    dropdownIcon?: ReactNode;
    dropdownLabel?: string;
    trigger?: ("contextMenu" | "click" | "hover")[];
    className?: string;
    tooltipOverlay?: string;
    image?: ReactNode;
}

export const ActionDropdownButtonWithoutParent = ({
    isDisabled,
    children,
    dropdownIcon,
    dropdownLabel,
    trigger,
    className,
    tooltipOverlay,
    image,
}: PropsWithChildren<ActionDropdownButtonWithoutParentProps>) => {
    const overlay = <Menu>{children}</Menu>;
    const triggerButton = (
        <Button
            image={image}
            icon={dropdownIcon}
            label={dropdownLabel}
            disabled={isDisabled}
            variation="dark"
        />
    );
    return (
        <Dropdown
            trigger={trigger ?? ["click", "hover"]}
            className={`actionDropdownButton${isDisabled ? " button--disabled" : ""} ${className}`}
            overlay={overlay}
            disabled={isDisabled}
        >
            {tooltipOverlay ? (
                <div>
                    <Tooltip overlay={tooltipOverlay} align={{ offset: [0, 15] }}>
                        {triggerButton}
                    </Tooltip>
                </div>
            ) : (
                triggerButton
            )}
        </Dropdown>
    );
};
